import { render } from "./profile-info.vue?vue&type=template&id=35b30b0c"
import script from "./profile-info.vue?vue&type=script&lang=js"
export * from "./profile-info.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__